// StaffNotice.js - Final Version (Exactly like Notice.js)
import React, { useContext, useEffect, useState } from "react";
import { Container, Modal, Button } from "react-bootstrap";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import axios from "axios";
import { getCachedData, setCachedData } from "../utils/apiCache";

const NewsLetterPage = () => {
  const [notices, setNotices] = useState([]);
  const [filteredNotices, setFilteredNotices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const authtoken = localStorage.getItem("token");
  const { GetstudentData } = useContext(ProductContext);

  const classSectionId = GetstudentData?.class_section_id;
  console.log(classSectionId, "classSectionId 1500");

  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);

  // Time ago function
  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInMs = now - past;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInDays < 30) return `${diffInDays}d ago`;
    return past.toLocaleDateString("en-GB");
  };

  // Open Modal with full notice details
  const openNoticeModal = (notice) => {
    setSelectedNotice(notice);
    setShowModal(true);
  };

  useEffect(() => {
    if (classSectionId) {
      const cacheKey = `newsletter_${classSectionId}`;
      const cached = getCachedData(cacheKey);
      if (cached) {
        setNotices(cached);
        setFilteredNotices(cached);
        setLoading(false);
        
      }
      if (!cached) setLoading(true);
      axios
        .get(
          `https://api.mirai.healthcare/api/head/newsletter/classSection/${classSectionId}`,
          {
            headers: { "x-auth": authtoken },
          }
        )
        .then((response) => {
          const noticesData = response?.data?.data || [];
          const sortedNotices = [...noticesData].sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          setNotices(sortedNotices);
          setFilteredNotices(sortedNotices);
          setCachedData(cacheKey, sortedNotices);
        })
        .catch((error) => {
          console.error("Error fetching newsletters:", error);
        })
        .finally(() => setLoading(false));
    }
  }, [classSectionId]);
  console.log(notices, "notices New api");

  

  // Paginated Data
  const paginatedNotices = notices.slice(0, page * pageSize);
  const hasMore = notices.length > paginatedNotices.length;

  return (
    <div className="page-wrapper min-vh-100">
      <Header />

      <div className="content px-4 pt-5">
        {/* Page Header */}
        <div className="text-center mb-4">
          <h2 className="page-title fw-bold mb-0">
            <i className="ti ti-bell-ringing me-2 text-primary"></i>
            News Letter
          </h2>
          <p className="text-muted">Latest announcements from administration</p>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white border-0 pb-0">
            <h4 className="mb-0">
              <i className="ti ti-timeline me-2 text-primary"></i>
              News Letter Timeline
            </h4>
          </div>

          <div className="card-body py-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : notices?.length === 0 ? (
              <div className="text-center py-5">
                <i className="ti ti-bell-off text-muted display-1"></i>
                <h5 className="mt-3 text-muted">No Notices Available</h5>
                <p>Check back later for updates from the school.</p>
              </div>
            ) : (
              <>
                <div className="timeline position-relative">
                  {paginatedNotices.map((notice) => (
                    <div key={notice.id} className="timeline-item mb-5">
                      <div className="timeline-dot bg-primary rounded-circle">
                        <i className="ti ti-bell text-white"></i>
                      </div>

                      <div className="timeline-content card shadow-sm p-4 border-0 hover-lift">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <h5 className="mb-0 text-primary">
                            <i className="ti ti-megaphone me-2"></i>
                            {notice.notice_heading}
                          </h5>
                          <span className="badge bg-success-soft text-success">
                            Approved
                          </span>
                        </div>

                        <p className="text-muted mb-3 line-clamp-2">
                          {notice.description}
                        </p>

                        <div className="row g-3 text-muted small NewBorderTop">
                          <div className="col-md-4">
                            <p className="mb-2 fs-14 text-black">
                              <i className="ti ti-calendar-event text-primary me-2"></i>
                              <strong>Date:</strong>{" "}
                              {new Date(notice.date).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                }
                              )}
                            </p>
                          </div>
                          <div className="col-md-4">
                            <p className="mb-2 fs-14 text-black">
                              <i className="ti ti-clock text-primary me-2"></i>
                              <strong>Posted:</strong>{" "}
                              {timeAgo(notice.created_at)}
                            </p>
                          </div>
                          <div className="col-md-4 text-md-end">
                            {notice.file_upload && (
                              <span className="badge bg-info-soft text-info me-2">
                                <i className="ti ti-paperclip me-1"></i>
                                Attachment
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="mt-3 text-end">
                          <button
                            onClick={() => openNoticeModal(notice)}
                            className="btn btn-outline-primary btn-sm"
                          >
                            <i className="ti ti-eye me-2"></i>
                            View Notice
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Load More Button */}
                {hasMore && (
                  <div className="text-center mt-5">
                    <button
                      onClick={() => setPage(page + 1)}
                      className="btn btn-primary px-4"
                    >
                      <i className="ti ti-chevron-down me-2"></i>
                      Load More Notices
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Full Notice Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-primary">
            <i className="ti ti-megaphone me-2"></i>
            {selectedNotice?.notice_heading}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
          {selectedNotice?.file_upload && (
            <div className="text-center mb-4">
              <img
                src={selectedNotice.file_upload}
                alt="Notice Attachment"
                className="img-fluid rounded shadow"
                style={{ maxHeight: "300px", objectFit: "contain" }}
              />
            </div>
          )}

          <div className="bg-light p-4 rounded">
            <h6 className="text-primary mb-2">
              <i className="ti ti-info-circle me-2"></i>
              Notice Details
            </h6>

            <div className="row g-3 text-muted small NewBorderTop">
              <div className="col-6 fs-14 text-black">
                <strong>Date:</strong>{" "}
                {selectedNotice?.date
                  ? new Date(selectedNotice.date).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  : "N/A"}
              </div>
              <div className="col-6 fs-14 text-black">
                <strong>Posted:</strong> {timeAgo(selectedNotice?.created_at)}
              </div>
            </div>
            <p className="mt-3 pt-2 NewBorderTop">
              {selectedNotice?.description}
            </p>

            {selectedNotice?.file_upload && (
              <div className="mt-4 text-center">
                <a
                  href={selectedNotice.file_upload}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success"
                >
                  <i className="ti ti-download me-2"></i>
                  Download Attachment
                </a>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Same Timeline Styling as Notice.js */}
      <style jsx>{`
        .timeline {
          padding-left: 40px;
        }
        .timeline::before {
          content: "";
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          width: 3px;
          background: linear-gradient(to bottom, #4361ee, #3f37c9);
          border-radius: 2px;
        }
        .timeline-item {
          position: relative;
        }
        .timeline-dot {
          position: absolute;
          left: -40px;
          top: 15px;
          width: 40px;
          height: 40px;
          background: #4361ee;
          border: 5px solid #fff;
          box-shadow: 0 0 0 4px #e0e7ff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        .timeline-content {
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(67, 97, 238, 0.15) !important;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .bg-success-soft {
          background-color: rgba(34, 197, 94, 0.1) !important;
          color: #22c55e !important;
        }
        .bg-info-soft {
          background-color: rgba(59, 130, 246, 0.1) !important;
          color: #3b82f6 !important;
        }
      `}</style>
    </div>
  );
};

export default NewsLetterPage;
